import React, { useContext, useEffect, useState } from "react";
import { getAuth, signInWithPopup, GoogleAuthProvider, signOut} from "firebase/auth";

const AuthContext = React.createContext();

export function useAuth() {
	return useContext(AuthContext);
}

export function AuthProvider({ children }) {
	const [auth, setAuth] = useState();
	const [provider, setProvider] = useState();
	const [currentUser, setCurrentUser] = useState();

	useEffect(() => {
		setAuth(getAuth());
		setProvider(new GoogleAuthProvider());
	}, []);

	useEffect(() => {
		if (auth) {
			const unsubscribe = auth.onAuthStateChanged((user) => {
				// Detaching the listener
				if (user) {
					setCurrentUser(user);
				} else {
					setCurrentUser(null);
				}
			});
			return () => unsubscribe(); // Unsubscribing from the listener when the component is unmounting.
		}
	}, [auth]);

	const signInWithGoogle = () => {
		signInWithPopup(auth, provider)
			.then((result) => {
				//const credential =
				// GoogleAuthProvider.credentialFromResult(result);
				// const token = credential.accessToken;
				// const user = result.user;
			})
			.catch((error) => {
				console.error({...error});
			});
	};
	const signOutToGoogle = () => {
		signOut(auth)
			.then(() => {
				// Sign-out successful.
			})
			.catch((error) => {
				// An error happened.
				console.error({...error});
			});
	}

	const value = { currentUser, signIn: signInWithGoogle, signOut: signOutToGoogle};
	return (
		<AuthContext.Provider value={value}>{children}</AuthContext.Provider>
	);
}
